//  import Vue from 'vue';
import * as types from '../mutation-types';

const state = {
  productType: null,
  aceptedTerms: false,
  usingRenew: false,
  renewFrecuency: 7,
  recharge: 'Q0'
};

const getters = {
  productType: () => state.productType,
  aceptedTerms: () => state.aceptedTerms,
  usingRenew: () => state.usingRenew,
  renewFrecuency: () => state.renewFrecuency,
  recharge: () => state.recharge
};

const actions = {
  toUsingRenew: ({ commit }, status) => {
    commit(types.SET_USING_RENEW, status);
  },
  setRenewFrecuency: ({ commit }, frecuency) => {
    commit(types.SET_RENEW_FRECUENCY, frecuency);
  },
  checkTerms: ({ commit }, status) => {
    commit(types.SET_ACEPTED_TERMS, status);
  },
  setProductType: ({ commit }, productType) => {
    commit(types.SET_PRODUCT_TYPE, productType);
  },
  resetPurchaseValues: ({ dispatch }) => {
    dispatch('checkTerms', false);
    dispatch('setProductType', false);
    dispatch('setRenewFrecuency', false);
    dispatch('toUsingRenew', false);
  },
  setRecharge: ({ commit }, value) => {
    commit(types.SET_RECHARGE, value);
  }
};

const mutations = {
  [types.SET_RENEW_FRECUENCY](_, frecuency) {
    state.renewFrecuency = frecuency;
  },
  [types.SET_USING_RENEW](_, status) {
    state.usingRenew = status;
  },
  [types.SET_ACEPTED_TERMS](_, status) {
    state.aceptedTerms = status;
  },
  [types.SET_PRODUCT_TYPE](_, productType) {
    state.productType = productType;
  },
  [types.SET_RECHARGE](_, value) {
    state.recharge = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase.js